import React, { useEffect, useRef, useState } from 'react'
import * as opdRegisteredCrud from '../../../configurations/crud/opdRegisteredCrud'
import { useToast } from '../../controls/Toast/ToastService';
import { MdErrorOutline } from 'react-icons/md';
import { Link, useParams } from 'react-router-dom';
import { PAGE_SIZE } from '../../../configurations/initUrls';
import Paging from '../../controls/Paging';
import ConfirmOnline from './ConfirmOnline';
import { EOPDRegisteredStatusBg, GetEOPDRegisterstatus, GetEOPDRegisterStatusName } from '../../../configurations/enums/EOPDRegisteredStatus';
import StatusContainer from '../../controls/StatusContainer';
import { IoCheckmarkCircleOutline } from 'react-icons/io5';
import LoadingContainer from '../../controls/LoadingContainer';
import { GetEGenderName } from '../../../configurations/enums/EGender';
import useGlobalLoader from '../../../configurations/useGlobalLoader';
import Empty from '../../controls/Empty';
import { PrintStarterDash } from '../settings/Prints/PrintStaterDash';
import { ConfirmOpdPrint } from '../settings/Prints/ConfirmOpdPrint';
import { PrescriptionLetterPrint } from '../settings/Prints/PrescriptionLetterPrint';

export default function ReceptionRegistered({ isActive, searchTerm, isSearch }) {
    const [isOpenPrint, setIsOpenPrint] = useState(false)
    const [printData, setPrintData] = useState()
    const printRef = useRef()
    const printLetterRef = useRef()

    const { start, end } = useGlobalLoader()
    const { centerid } = useParams()
    const toast = useToast()
    const [LastPage, setLastPage] = useState(1);
    const [pagingData, setPagingData] = useState();
    const [loding, setLoding] = useState(false)
    const [userData, setUserData] = useState([]);
    const [lodingCrud, setLodingCrud] = useState(false)
    const [isOpenAdd, setIsOpenAdd] = useState(false)
    const [addData, setAddData] = useState()
    const [currentPage, setCurrentPage] = useState(1)


    useEffect(() => {
        if (isActive) {
            onSearch()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isSearch])

    const OnPageChange = (e) => {
        setCurrentPage(e)
        GetTodaysRegistered({
            CenterId: centerid,
            PageNo: e,
            PageSize: PAGE_SIZE,
            SearchTerm: searchTerm
        })
    }

    const onSearch = () => {
        GetTodaysRegistered({
            CenterId: centerid,
            PageNo: 1,
            PageSize: PAGE_SIZE,
            SearchTerm: searchTerm
        })
    }

    const GetTodaysRegistered = (params) => {
        setLoding(true)
        start()
        opdRegisteredCrud.GetTodaysRegistered(params).then(res => {
            let mdata = res.data
            if (mdata.result.succeeded) {
                setUserData(mdata.data)
                setPagingData(mdata.paging)
                setLastPage(mdata.paging.pageCount)
            } else {
                setPagingData()
                setLastPage(1)
                setUserData([])
                toast.open(mdata.result.message, <MdErrorOutline />, "danger")
            }
            setLoding(false)
            end()
        }).catch(errors => {
            setPagingData()
            setLastPage(1)
            setUserData([])
            setLoding(false)
            end()
            toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
        })
    }

    const confirmOnline = (param, setValues) => {
        setLodingCrud(true)
        start()
        opdRegisteredCrud.ConfirmOnline(param).then(res => {
            let mdata = res.data
            if (mdata.result.succeeded) {
                setValues({
                    Id: 0,
                    Comment: "N/A",
                    BloodPressure: "N/A",
                })
                setIsOpenAdd(false)
                onSearch()
                setPrintData(mdata.data)
                setIsOpenPrint(true)
                toast.open(
                    <div className='flex flex-col'>
                        <span>Confirmed Successfully! Ref No: {mdata.data.id}</span>
                        <a href={`/#/checkconfirmed/${mdata.data.id}`} target='_blank' className='hover:underline text-blue-700 font-semibold' >Click to get confirmation details</a>
                    </div>
                    , <IoCheckmarkCircleOutline />, "success", 30000)
            } else {
                toast.open(mdata.result.message, <MdErrorOutline />, "danger")
                setIsOpenAdd(false)
            }
            setLodingCrud(false)
            end()
        }).catch(errors => {
            setLodingCrud(false)
            end()
            setIsOpenAdd(false)
            toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
        })
    }

    // Confirm button (pending) OR status badge
    const renderAction = (item) => (
        item.status == 2 ? (
            <button
                type="button"
                title="Pending"
                onClick={() => { setAddData(item.id); setIsOpenAdd(!isOpenAdd) }}
                className="rounded-lg bg-brand-500 px-3 py-1.5 text-sm font-medium text-white transition hover:bg-brand-600 focus:outline-none focus:ring-2 focus:ring-brand-500 active:scale-95"
            >
                Confirm
            </button>
        ) : (
            <StatusContainer bg={EOPDRegisteredStatusBg(item.status)} text={GetEOPDRegisterStatusName(item.status)} />
        )
    )

    return (
        <div className="text-gray-700">
            <Paging LastPage={LastPage} CurrentPage={currentPage} OnPageChange={OnPageChange} pagingData={pagingData}>

                {loding ? (
                    <LoadingContainer text="Fetching..." />
                ) : userData.length > 0 ? (
                    <>
                        {/* ===== desktop table ===== */}
                        <div className="hidden overflow-x-auto sm:block">
                            <table className="w-full border-collapse text-left text-sm text-gray-500">
                                <thead>
                                    <tr className="bg-gray-100 text-xs uppercase tracking-wide text-gray-500">
                                        <th scope="col" className="px-3 py-3 font-semibold">Ref.No</th>
                                        <th scope="col" className="px-3 py-3 font-semibold">OPD No.</th>
                                        <th scope="col" className="px-3 py-3 font-semibold">Name</th>
                                        <th scope="col" className="px-3 py-3 font-semibold">Phone</th>
                                        <th scope="col" className="px-3 py-3 font-semibold">Age</th>
                                        <th scope="col" className="px-3 py-3 font-semibold">Action</th>
                                        <th scope="col" className="px-3 py-3 font-semibold">Address</th>
                                    </tr>
                                </thead>
                                <tbody className="divide-y divide-gray-100">
                                    {userData.map((item, index) => (
                                        <tr key={index} className="bg-white hover:bg-gray-50">
                                            <td className="px-3 py-2.5">{item.id}</td>
                                            <td className="px-3 py-2.5">{item.opdNumberAlloted}</td>
                                            <td className="whitespace-nowrap px-3 py-2.5 font-bold text-gray-800">
                                                {item.patientName} <span className="text-[9px] font-normal text-gray-400">({GetEGenderName(item.gender)})</span>
                                            </td>
                                            <td className="px-3 py-2.5">{item.mobile}</td>
                                            <td className="px-3 py-2.5">{item.age}</td>
                                            <td className="w-28 px-3 py-2.5">{renderAction(item)}</td>
                                            <td className="whitespace-nowrap px-3 py-2.5">{item.patientAddress}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                        {/* ===== mobile cards ===== */}
                        <div className="space-y-2 p-2 text-left sm:hidden">
                            {userData.map((item, index) => (
                                <div key={index} className="border-b-2 border-gray-100 bg-white p-3">
                                    <div className="flex items-start justify-between gap-2">
                                        <div className="min-w-0">
                                            <div className="font-bold text-gray-900">
                                                {item.patientName} <span className="text-xs font-normal text-gray-400">({GetEGenderName(item.gender)})</span>
                                            </div>
                                            <div className="mt-0.5 text-xs text-gray-500">
                                                Ref: {item.id} · OPD: {item.opdNumberAlloted} · Age: {item.age}
                                            </div>
                                        </div>
                                        <div className="shrink-0">{renderAction(item)}</div>
                                    </div>
                                    <div className="mt-2 space-y-1 text-xs text-gray-600">
                                        <div><span className="text-gray-400">Phone: </span>{item.mobile}</div>
                                        <div><span className="text-gray-400">Address: </span>{item.patientAddress}</div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </>
                ) : (
                    <Empty>No Items Found.</Empty>
                )}
            </Paging>

            <div className="pb-4" />

            <ConfirmOnline ConfirmOnline={confirmOnline} id={addData} isOpen={isOpenAdd} setIsOpen={setIsOpenAdd} loding={lodingCrud} />

            {isOpenPrint && printData && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4">
                    <div className="w-full max-w-md rounded-2xl bg-white p-6 shadow-xl">
                        <div className="flex flex-col items-center justify-center gap-3">
                            <div className="flex items-center justify-center gap-2">
                                <IoCheckmarkCircleOutline className="text-2xl text-green-500" />
                                <h1 className="text-xl font-semibold text-green-600">OPD Confirmed Successfully.</h1>
                            </div>

                            <div className="flex flex-wrap items-center justify-center gap-3">
                                <PrintStarterDash printRef={printRef} text="Print Slip" />
                                <PrintStarterDash printRef={printLetterRef} text="Print Prescription Letter" />
                            </div>

                            <div style={{ display: "none" }}>
                                <ConfirmOpdPrint printData={printData} ref={printRef} />
                                <PrescriptionLetterPrint printData={printData} ref={printLetterRef} />
                            </div>

                            <button
                                onClick={() => setIsOpenPrint(false)}
                                className="mt-2 text-sm text-blue-600 hover:text-blue-800 hover:underline"
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}